import { render } from "./XIconSolidCreditCard.vue?vue&type=template&id=835d1466"
import script from "./XIconSolidCreditCard.vue?vue&type=script&lang=js"
export * from "./XIconSolidCreditCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidCreditCard.vue"]])

export default __exports__